/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Copilot_Risk_ProhibitedInputs */



/**
* | output |
* | --- |
* | "Prohibited (Unacceptable)" |
*
* @param {Compliance_Copilot_Risk_ProhibitedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_copilot_risk_prohibited = /** @type {((inputs?: Compliance_Copilot_Risk_ProhibitedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Copilot_Risk_ProhibitedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verboten (Unzulässig)")
	return /** @type {LocalizedString} */ ("Prohibited (Unacceptable)")
});